import { Lookbook, Market } from '@typings';
import { flatten, groupBy, map, pipe, prop, values } from 'ramda';

import { isDefined } from '../utils/is';

export type LookbookLocationContext = 'wishlist' | 'products' | 'cms';

export const lookbookLocationToTracking = {
  cms: 'lookbookCmsPage',
  products: 'lookbookPage',
  wishlist: 'lookbookWishlistPage',
} as const;
/**
 * Gets market name from list of markets based on its id
 */
export const getMarketName = (markets: Market[] | undefined, id: string): string => {
  if (!isDefined(markets)) {
    return '';
  }

  const market = markets.find(item => item.market === id);

  return isDefined(market) ? market.name : '';
};

/**
 * Gets owner name from list of owners based on its id
 */
export const getOwnerName = (owners: Lookbook.Owner[], id: string): string => {
  const owner = owners.find(item => item.owner === id);

  return isDefined(owner) ? owner.name : '';
};

export const getIsPageNavigationItem = (item: Lookbook.NavigationItem): item is Lookbook.PageNavigationItem => item.type === 'page';

export const getIsLinkNavigationItem = (item: Lookbook.NavigationItem): item is Lookbook.LinkNavigationItem => item.type === 'link';

export const getIsFolderNavigationItem = (item: Lookbook.NavigationItem): item is Lookbook.FolderNavigationItem => item.type === 'folder';

export const getLookbookPageIdsGroupedBySlug = pipe(
  (pages: Lookbook.Page[]) => groupBy(prop('slug'), pages),
  values,
  flatten,
  map(prop('id')),
);
